<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Consulta de Projetos de Pesquisa'"></basic-toolbar>

          <v-card-text>

            <v-form v-model="formularioValido" ref="form">
              <v-container  @keyup.enter="consultar()">

                <!-- Número de registro e Título -->
                <v-layout row wrap justify-space-between>

                  <!-- Nº Registro -->
                  <v-flex xs11 sm3>
                    <v-text-field
                      label='Nº Registro'
                      v-model="consulta.numRegistro"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>

                  <!-- Título -->
                  <v-flex xs11 sm8>
                    <v-text-field
                      label='Título'
                      v-model="consulta.titulo"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Palavra-chave e Membro da equipe -->
                <v-layout row wrap justify-space-between>

                  <!-- Palavra-chave -->
                  <v-flex xs11 sm3>
                    <v-text-field
                      label='Palavra-chave'
                      v-model="consulta.palavraChave"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>

                  <!-- Membro da equipe -->
                  <v-flex xs11 sm8>
                    <v-text-field
                      label='Membro da equipe'
                      v-model="consulta.membroEquipe"
                      max-height="400"
                      clearable>
                    </v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Área do Conhecimento e Nome da Área -->
                <v-layout v-if="consultaAvancada" row wrap justify-space-between>

                  <!-- Área do Conhecimento -->
                  <v-flex xs11 sm5>
                    <v-select
                      label='Área do Conhecimento'
                      :items="listaAreaDoConhecimento"
                      v-model="consulta.areaConhecimento"
                      item-text="descricao"
                      item-value="id"
                      clearable
                      autocomplete
                      @input='getNomesDasAreas(consulta.areaConhecimento)'
                      @click:clear="limpaNomeAreaSubarea()" >
                    </v-select>
                  </v-flex>

                  <!-- Nome da Área -->
                  <v-flex xs11 sm5>
                    <v-select
                      label='Nome da Área'
                      :items="listaNomeArea"
                      v-model="consulta.nomeArea"
                      item-text="descricao"
                      item-value="id"
                      :disabled="nomeAreaDisabled"
                      clearable
                      autocomplete
                      @input='getNomesDasSubareas(consulta.nomeArea)' 
                      @click:clear="limpaNomeSubarea()">
                    </v-select>
                  </v-flex>

                </v-layout>

                <!-- Nome da Subárea e Linha de Pesquisa no Programa de Pós-Graduação -->
                 <v-layout v-if="consultaAvancada" row wrap justify-space-between>

                  <!-- Nome da Subárea -->
                  <v-flex xs11 sm5>
                    <v-select
                      label='Nome da Subárea'
                      :items="listaNomeSubarea"
                      v-model="consulta.nomeSubarea"
                      item-text="descricao"
                      item-value="id"
                      :disabled="nomeSubareaDisabled || listaNomeSubarea.length === 0"
                      clearable
                      autocomplete>
                    </v-select>
                  </v-flex>

                  <!-- Linha de Pesquisa no Programa de Pós-Graduação -->
                  <v-flex xs11 sm5>
                    <v-select
                      label='Linha de Pesquisa no Programa de Pós-Graduação'
                      :items="listaLinhaPesquisaPPG"
                      v-model="consulta.linhaPesquisaPPG"
                      clearable
                      autocomplete
                      disabled
                      hint="Esta opção está indisponível no momento."
                      persistent-hint>
                    </v-select>
                  </v-flex>

                </v-layout>

                <!-- Consulta avançada e Consulta simples -->
                <v-layout row wrap justify-end>
                  <v-btn v-if="!consultaAvancada" color="primary" text @click="abrirConsultaAvancada()">Consulta avançada</v-btn>
                  <v-btn v-else color="primary" text @click="fecharConsultaAvancada()">Consulta simples</v-btn>
                </v-layout>

                <!-- Botões "Limpar" e "Consultar" -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 style="padding-top:15px">
                    <div align="center">

                      <!-- "Limpar" -->
                      <v-btn style="margin-right: 10px;" color="primary" @click="limpar()">Limpar</v-btn>

                      <!-- "Consultar" -->
                      <v-btn color="primary" @click="consultar()">Consultar</v-btn>

                    </div>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
          </v-card-text>
        </v-card>

        <br><br><br><br>

        <v-card class="text-xs-center">

          <!-- Resultados da Consulta -->
          <basic-toolbar :title="'Resultados da Consulta'"></basic-toolbar>

          <v-card-text>

          <!-- Tabela com projetos -->
          <v-data-table
            :headers="headers"
            :items="listaProjetosPesquisa"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
          >
            <!-- Ícones da coluna "Opções" -->
            <template v-slot:item.opcoes="props">

              <!-- Ícone para visualizar o cadastro do projeto -->
              <c-tooltip-btn
              icon="library_books"
              color="primary"
              tooltip="Visualizar cadastro do projeto"
              @click="toAbrirCadastroProjetoPesquisa(props.item.id)"
              ></c-tooltip-btn>

            </template>

            <!-- Formata o número de registro -->
            <template v-slot:item.numRegistro="props">{{props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro}}</template>

            <!-- Formata a sigla -->
            <template v-slot:item.sigla="props">{{props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla}}</template>

            <!-- Formata a data de início -->
            <template v-slot:item.dataInicio="props">{{dates.format(props.item.dataInicio)}}</template>

             <!-- Número total de projetos -->
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetosPesquisa.length }} {{ listaProjetosPesquisa.length > 1 ? 'projetos' : 'projeto' }}
            </template>
            
          </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'items'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      consulta: {
        numRegistro: '',
        titulo: '',
        membroEquipe: '',
        palavraChave: '',
        areaConhecimento: '',
        nomeArea: '',
        nomeSubarea: '',
        linhaPesquisaPPG: ''
      },
      consultaAvancada: false,
      listaAreaDoConhecimento: [],
      listaNomeArea: [],
      listaNomeSubarea: [],
      listaLinhaPesquisaPPG: [],
      nomeAreaDisabled: true,
      nomeSubareaDisabled: true,
      listaProjetosPesquisa: [],
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nº Registro', align: 'left', value: 'numRegistro' },
        { text: 'Título', align: 'left', value: 'titulo' },
        { text: 'Sigla', align: 'left', value: 'sigla' },
        { text: 'Data de início', align: 'left', value: 'dataInicio' },
        { text: 'Prazo (meses)', align: 'left', value: 'prazoMeses' },
        { text: 'Situação', align: 'left', value: 'situacao.descricao' },
        { text: 'Coordenador', align: 'left', value: 'coordenador' },
        { text: 'Opções', align: 'left', value: 'opcoes' }
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Limpa nome das áreas e subáreas.
      limpaNomeAreaSubarea: function () {
        this.listaNomeArea = []
        this.nomeAreaDisabled = true
        this.consulta.nomeArea = ''
        this.limpaNomeSubarea()
      },

      // Limpa nome das subáreas.
      limpaNomeSubarea: function () {
        this.listaNomeSubarea = []
        this.nomeSubareaDisabled = true
        this.consulta.nomeSubarea = ''
      },

      // Carrega as áreas.
      getNomesDasAreas: function (idClassifSup) {
        this.obtemNomesDasAreas(idClassifSup, this, 'listaNomeArea')
        this.nomeAreaDisabled = false
        this.listaNomeSubarea = []
        this.nomeSubareaDisabled = true
      },

      // Carrega as subáreas.
      getNomesDasSubareas: function (idClassifSup) {
        this.obtemNomesDasSubareas(idClassifSup, this, 'listaNomeSubarea')
        this.nomeSubareaDisabled = false
      },

      // Carrega as áreas do conhecimento do CNPq.
      obtemAreasDoConhecimento: function (aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' })
        projetos.getClassificacoesAreasDoConhecimento()
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' })
        })
      },

      // Carrega os nomes das áreas.
      obtemNomesDasAreas: function (idClassifSup, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' })
        projetos.getClassificacoesClassificacaoSuperior(idClassifSup)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' })
        })
      },

      // Carrega os nomes das subáreas.
      obtemNomesDasSubareas: function (idClassifSup, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' })
        projetos.getClassificacoesClassificacaoSuperior(idClassifSup)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' })
        })
      },

      // Abre filtros da consulta simples.
      abrirConsultaAvancada () {
        this.consultaAvancada = true
      },

      // Fecha filtros da consulta avançada.
      fecharConsultaAvancada () {
        this.consultaAvancada = false
      },

      // Abre o cadastro do projeto de pesquisa.
      toAbrirCadastroProjetoPesquisa: function (idProjetoPesquisa) {
        this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: {idProjetoPesquisa: idProjetoPesquisa} })
      },

      // Limpa os campos do formulário de consulta.
      limpar () {
        this.consulta = {}
      },

      // Consulta projetos de pesquisa.
      consultar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Consultando projetos de pesquisa...' })
        projetos.getConsultaProjetosPesquisa(this.consulta)
        .then(response => {
          this.listaProjetosPesquisa = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaProjetosPesquisa = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Consultando projetos de pesquisa...' })
        })
      }
    },
    mounted () {
      // Carrega as áreas do conhecimento do CNPq.
      this.obtemAreasDoConhecimento(this, 'listaAreaDoConhecimento')
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-tooltip-btn': TootipButton
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }
  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// consulta-projetos-pesquisa.vue?79fbdcc8